


























import { Vue, Component, Prop } from 'vue-property-decorator';
import { Attribute } from '@/interfaces/Attribute';
import StepEnvironmentInput from '@/components/FormElements/StepEnvironmentInput.vue';
import AttributeCategorizedListTabItemCardTable from '@/components/Attributes/AttributeCategorizedListTabItemCardTable.vue';
import { Environment } from '@/interfaces/Environment';

@Component({
  components: { AttributeCategorizedListTabItemCardTable, StepEnvironmentInput }
})
export default class AttributesViewCard extends Vue {
  @Prop()
  attribute!: Attribute;

  @Prop()
  environments!: Environment[];

  @Prop()
  parentAttribute!: Attribute;

  @Prop()
  selectedEnvironment?: number;
}
